// Preguntas del cuestionario de referencias, por idioma.
// Cada una tiene: id (estable), text (con {candidateName}), type, required.
//
// Los ids se mantienen (q1...q8) para no romper las respuestas ya guardadas en
// `reference_intake_tokens.responses`, que están indexadas por ese id.
//
// NINGUNA ES OBLIGATORIA: quien responde está haciendo un favor, y un asterisco
// rojo en ocho preguntas es la forma más rápida de que abandone a la mitad.
//
// Este archivo lo usan LOS DOS flujos: la petición que envía Rutment desde
// rutment.com y la que envía el propio candidato desde el portal. Un solo sitio
// para las preguntas evita que los dos cuestionarios se separen con el tiempo.

export const DEFAULT_REFERENCE_QUESTIONS_ES = [
  { id: "q1", text: "Fechas en las que trabajasteis juntos:", type: "textarea", required: false },
  { id: "q2", text: "Vuestra relación profesional:", type: "textarea", required: false },
  { id: "q3", text: "¿Cuáles son sus principales fortalezas o áreas en las que destaca?", type: "textarea", required: false },
  { id: "q4", text: "¿Cuáles son sus debilidades o áreas de mejora?", type: "textarea", required: false },
  { id: "q5", text: "En tu opinión, ¿qué estilo de liderazgo sacaría lo mejor de esta persona?", type: "textarea", required: false },
  { id: "q6", text: "¿Qué tipo de cultura de empresa y entorno de trabajo encajaría mejor con ella?", type: "textarea", required: false },
  { id: "q7", text: "¿Recuerdas alguna situación difícil a la que se enfrentara y cómo la gestionó? (Da un ejemplo si es posible)", type: "textarea", required: false },
  { id: "q8", text: "¿Algún comentario adicional sobre el candidato?", type: "textarea", required: false },
];

export const DEFAULT_REFERENCE_QUESTIONS_EN = [
  { id: "q1", text: "Dates you worked together:", type: "textarea", required: false },
  { id: "q2", text: "Your work relationship:", type: "textarea", required: false },
  { id: "q3", text: "What are their main strengths or areas where they excel?", type: "textarea", required: false },
  { id: "q4", text: "What are their weaknesses or areas for improvement?", type: "textarea", required: false },
  { id: "q5", text: "In your opinion, what leadership style would bring out their best performance?", type: "textarea", required: false },
  { id: "q6", text: "What type of company culture and work environment would be the best fit for them?", type: "textarea", required: false },
  { id: "q7", text: "Can you recall any challenging situation they faced and how they handled it? (Please provide an example if possible)", type: "textarea", required: false },
  { id: "q8", text: "Any additional comments about the candidate?", type: "textarea", required: false },
];

export const getDefaultReferenceQuestions = (lang) =>
  lang === "es" ? DEFAULT_REFERENCE_QUESTIONS_ES : DEFAULT_REFERENCE_QUESTIONS_EN;

// Rellena el marcador {candidateName}
export const fillQuestionTemplate = (text, candidateName) =>
  (text || "").replace(/\{candidateName\}/g, candidateName || "");
